export const DETAILS_GRID_STYLES = "grid gap-8";

export const DETAILS_SECTION_STYLES = "grid gap-4";

export const SECTION_TITLE_STYLES =
  "text-primary flex-auto truncate text-xl font-medium leading-10";

export const ROW_SUBTITLE_STYLES = "text-stone-500 dark:text-stone-400";

export const SUB_HEADER_STYLES = `text-xs font-medium uppercase tracking-widest ${ROW_SUBTITLE_STYLES}`;

export const GROUP_STYLES =
  "overflow-hidden rounded bg-stone-50 dark:bg-stone-800 sm:rounded-lg";

export const ATTRIBUTE_GROUP_STYLES = "flex flex-wrap gap-2";
export const ROW_GRID_STYLES = "w-full flex justify-between gap-5";
export const DT_STYLES = "text-primary flex flex-1 items-center";
export const DD_STYLES = "text-right text-stone-700 dark:text-stone-300";

export const SHORT_INPUT_STYLES = "w-20";

export const SM_LONG_INPUT_STYLES = "sm:w-[66%]";

export const INVALID_INPUT_STYLES =
  "invalid:text-red-600 invalid:border-red-600 dark:invalid:text-red-600 dark:invalid:border-red-600";

export const BORDER_INPUT_STYLES =
  "border border-stone-300 dark:border-stone-800 ";

export const FOCUS_INPUT_STYLES =
  "focus:outline-none focus:border-stone-500 focus:ring-stone-500 dark:focus:border-stone-500 dark:focus:ring-stone-500";

export const INPUT_DEFAULT_STYLES = `${BORDER_INPUT_STYLES} ${INVALID_INPUT_STYLES} ${FOCUS_INPUT_STYLES} w-full rounded-md pl-3 text-stone-900 placeholder-stone-400 dark:bg-stone-700 dark:text-stone-100 dark:placeholder-stone-400 sm:text-sm`;

export const INPUT_FIELD_STYLES = `${INPUT_DEFAULT_STYLES} block h-9 px-2 text-sm shadow-sm dark:border-stone-800 dark:text-white `;
export const FIXED_HEIGHT_ROW_STYLES = "h-[52px]";

export const ROW_TITLE_FONT_STYLES =
  "text-left text-sm text-stone-900 dark:text-white";

export const FULL_ROW_STYLES = "truncate max-sm:min-w-fit max-sm:max-w-full";

export const ROW_TITLE_STYLES = `${ROW_TITLE_FONT_STYLES} ${FULL_ROW_STYLES}`;

export const DIVIDED_STYLES = "divide-y divide-stone-100 dark:divide-black";

export const BORDER_STYLES = "border-stone-200 dark:border-stone-900";

export const SECTION_STYLES = `border-b pb-6 ${BORDER_STYLES}`;

export const SLIDE_OVER_PADDING_STYLES = "px-4 sm:px-8";
